/**
 * 发布表单校验(业务真源 App PublishPage.tsx:223-257,code-authoritative)。
 * 逐字段校验(field→文案)供字段级内联提示;validatePublish 保留"首个错误"兜底。
 * 关键 drift(勿照旧 doc):商品介绍下限 = 15(非 50);标题上限 = 60。
 */
export interface PublishFormValues {
  coverCount: number;
  title: string;
  categoryL1Id: string | null;
  categoryL2Id: string | null;
  description: string;
  /** 价格(元,字符串录入)。 */
  price: string;
  unit: string | null;
  medium: string | null;
}

export type PublishField =
  | 'cover'
  | 'title'
  | 'category'
  | 'description'
  | 'price'
  | 'unit'
  | 'medium';

export type PublishErrors = Partial<Record<PublishField, string>>;

/** 代码点长度(与 App `[...s].length` 一致,正确计中文/emoji)。 */
export const cpLen = (s: string): number => [...s].length;

export const TITLE_MAX = 60;
export const DESC_MIN = 15;
export const DESC_MAX = 2000;
export const PRICE_MIN = 9;
export const PRICE_MAX = 9999;

/** 首个错误的字段顺序(提交时定位/兜底文案)。 */
export const FIELD_ORDER: PublishField[] = [
  'cover',
  'title',
  'category',
  'description',
  'price',
  'unit',
  'medium',
];

/** 逐字段校验,返回 field→错误文案(空对象=全部通过)。字段级内联提示用此。 */
export function validatePublishFields(v: PublishFormValues): PublishErrors {
  const e: PublishErrors = {};

  if (v.coverCount === 0) e.cover = '请上传至少 1 张封面图';

  const title = v.title.trim();
  if (cpLen(title) === 0) e.title = '请填写商品标题';
  else if (cpLen(title) > TITLE_MAX) e.title = `标题最多 ${TITLE_MAX} 字`;

  if (!v.categoryL1Id) e.category = '请选择一级品类';
  else if (!v.categoryL2Id) e.category = '请选择二级品类';

  const dLen = cpLen(v.description);
  if (dLen < DESC_MIN || dLen > DESC_MAX) e.description = `商品介绍 ${DESC_MIN}-${DESC_MAX} 字`;

  const priceNum = Number(v.price);
  if (!Number.isFinite(priceNum) || !Number.isInteger(priceNum)) e.price = '价格必须为整数（元）';
  else if (priceNum < PRICE_MIN || priceNum > PRICE_MAX) e.price = `价格区间为 ¥${PRICE_MIN}-¥${PRICE_MAX}`;

  if (!v.unit) e.unit = '请选择计价单位';
  if (!v.medium) e.medium = '请选择商品介质';

  return e;
}

/** 通过返回 null,否则返回首个错误文案(提交级兜底,顺序同表单)。 */
export function validatePublish(v: PublishFormValues): string | null {
  const e = validatePublishFields(v);
  for (const f of FIELD_ORDER) {
    if (e[f]) return e[f]!;
  }
  return null;
}
